module.exports = __webpack_public_path__ + "images/business-class-feature-boards.511e144c0f72db99b819.png";